// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1oSOr","log":"ModalInventoryLogs_log__rxwj-","date":"ModalInventoryLogs_date__wsX-M","userName":"ModalInventoryLogs_userName__3qQEv"};